<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
    </base-header>
    <b-container fluid class="mt--7">   
      <div class="mt-5"></div>
      <card>
        <div class="export-data-header">
          <h2>Export data tab</h2>
          <base-button icon type="info" @click="showExportData=!(showExportData)">
            <span class="btn-inner--icon">
              <i :class="{'ni ni-fat-add':!showExportData,'ni ni-fat-delete':showExportData}"/>
            </span>
          </base-button>
          
        </div>
        <div v-if="showExportData">
          <popularity-filters name="exportFilters" @change="filterChanged" />
          <base-input label="Group columns" placeholder="Group columns">
            <b-dropdown text="Select one to add" variant="outline-light" class="m-2">
              <b-dropdown-item v-for="(v,k) in exportDataColumnOptions" :key="k+'exportdatagroupitem'" @click="addToExportColumns(k)">{{v}}</b-dropdown-item>
            </b-dropdown>
          </base-input>
          <template v-if="exportDataColumns.length>0">
            <template v-for="(v,k) in exportDataColumns">
              <div v-if="exportDataColumnOptions[v]!==undefined" class="badge badge-primary d-inline-flex align-items-center mr-1"  :key="'_type_filter_elem'+k">
                {{exportDataColumnOptions[v]}}
                <span class="closebtn" @click="deleteFromExportColumns(k)">&times;</span>
              </div>
            </template>
            
          </template>
          <h5>Example column groups:</h5>
          <div>
            <base-button v-for="(v,k) in exportDataColumnExamples" :key="k+'exportexample'" type="info" @click="exportDataColumns=v;$forceUpdate()">{{k}}</base-button>
          </div>
          <br>
          <base-button type="success" :disabled="exportingData" @click="exportData()">{{exportingData ? 'Exporting...' : 'Export data'}}</base-button>
        </div>
      </card>
      <popularity-table />
    </b-container>
  </div>
</template>

<script>
import PopularityTable from '@/views/Tables/PopularityTable.vue'
import PopularityFilters from '@/components/PopularityFilters';

import RepositoryFactory from '@/repositories/RepositoryFactory';

const PopularityDataRepository = RepositoryFactory.get('popularity_data')

export default {
    components:{
        [PopularityTable.name]:PopularityTable,
        [PopularityFilters.name]:PopularityFilters,
    },
    data(){
      return {
        showExportData:false,

        exportDataFilters:{},
        exportDataColumns:[],
        exportingData:false,

        exportDataColumnOptions:{
          'site':'Site ID',
          'site__name':'Site name',
          'week_day':'Week day',
          'hour':'Hour',
          'create_date__date':'Create date',
        },

        exportDataColumnExamples:{
          'Hourly weekdays average':['week_day','hour'],
          'Daily average':['create_date__date'],
          'Hourly average':['create_date__date','hour'],
          'Frequency hourly':['hour'],
          'Frequency daily':['week_day'],
        }
      }
    },
    methods:{
      filterChanged(newFilters){
        this.exportDataFilters=newFilters.filters;
      },
      addToExportColumns(value){
        if(this.exportDataColumns.includes(value))
          return;
        this.exportDataColumns.push(value);
        this.$forceUpdate();
      },
      deleteFromExportColumns(index){
        this.exportDataColumns.splice(index,1);
        this.$forceUpdate();
      },
      exportData(){
        this.exportingData=true;
        this.$notify({
          message: 'Exporting data... ',
          type: 'info',
          size: 'lg',
          timeout: 5000,
          showClose: true
        });
        var payload=this.copyObject(this.exportDataFilters);
        payload.charts={}
        payload.charts.export_data=this.exportDataColumns;
        payload.export=true;
        payload.current_value='all';

        PopularityDataRepository.getChart(payload,true).then((response) => {
          this.downloadExcelBlob(response,`export_data-${Math.floor(this.datetimeToTimestamp(new Date()))}.xlsx`);
          this.exportingData=false;
        }).catch((error) => {
          this.exportingData=false;
          this.$notify({
            message: 'Data export failed.',
            type: 'warning',
            size: 'lg',
            timeout: 5000,
            showClose: true
          });
          
        })

      }
    }
}
</script>

<style>

.export-data-header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap:10px;
}

</style>